import PropTypes from "prop-types"
import { useState } from "react"
import { DownloadOutlined } from "@mui/icons-material"
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material"
import type { SkillCatalogSkill } from "connected-components/skills/types"
import { useSkillDownload } from "connected-components/skills/hooks/use-skill-download"

interface SkillDownloadActionProps {
  skill: SkillCatalogSkill
}

export function SkillDownloadAction({ skill }: SkillDownloadActionProps) {
  const { downloadSkill, isDownloading } = useSkillDownload(skill)
  const [confirmOpen, setConfirmOpen] = useState(false)

  function handleConfirmDownload() {
    downloadSkill()
    setConfirmOpen(false)
  }

  return (
    <>
      <Tooltip title="Download workflow">
        <span>
          <IconButton
            size="small"
            color="primary"
            className="skill-card-download"
            aria-label={`Download ${skill.name}`}
            disabled={isDownloading}
            loading={isDownloading}
            onClick={() => setConfirmOpen(true)}
          >
            <DownloadOutlined fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>

      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogTitle>Download {skill.name}?</DialogTitle>
        <DialogContent>
          <Typography variant="body2">
            This will download the agentic workflow file to your device.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleConfirmDownload}>
            Download
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

SkillDownloadAction.propTypes = {
  skill: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    tier: PropTypes.oneOf(["licensed", "proprietary"]).isRequired,
  }).isRequired,
}
